module.exports = __webpack_public_path__ + "img/Plus2.4f9344fd.svg";